export const THREAD_PRESENCE_UPDATED = 'THREAD_PRESENCE_UPDATED';